import React from 'react';
import {colorsStyles} from '../utils/styles';

const InvoiceRequestedIcon = ({...rest}) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M13.333 7.333V4.533c0-1.12 0-1.68-.218-2.109a2 2 0 0 0-.874-.874C11.813 1.333 11.253 1.333 10.133 1.333H5.867c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.875.874c-.218.428-.218.988-.218 2.108v6.934c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .875.875c.428.218.988.218 2.108.218H8M5.333 4.667h5.334M5.333 7.333H8.667"
      stroke="#B5B8BF" strokeLinecap="round" strokeLinejoin="round"/>
    <rect
      x="6.667" y="6.667" width="9.333" height="9.333" rx="4.667"
      style={{fill: colorsStyles.primary_6}}/>
    <path
      d="M11.33 9.1V11.4L12.9 12.4" stroke="white" strokeWidth="1.1" strokeLinecap="round"
      strokeLinejoin="round" fill="none"/>
  </svg>
);

export default InvoiceRequestedIcon;
